import { render, staticRenderFns } from "./proxyScenarioConfiguration.vue?vue&type=template&id=b8544ec0"
import script from "./proxyScenarioConfiguration.vue?vue&type=script&lang=js"
export * from "./proxyScenarioConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports